module.exports = __webpack_public_path__ + "img/img3.c93c1181.jpg";